<nav
  class="sidebar d-flex flex-column"
  [class.collapsed]="isCollapsed"
  [class.mobile]="isMobile"
>
  <!-- Main Navigation Menu -->
  <ul>
    <!-- Dashboard Link -->
    <li>
      <a
        routerLink="/dashboard"
        routerLinkActive="active"
        (click)="isMobile && toggleSidebar()"
        [matTooltip]="
          isCollapsed && !isMobile ? ('layout.nav.dashboard' | translate) : null
        "
        matTooltipPosition="right"
        matTooltipClass="custom-tooltip"
      >
        <mat-icon class="nav-item-icon">dashboard</mat-icon>
        <span class="menu-label">{{ "layout.nav.dashboard" | translate }}</span>
      </a>
    </li>

    @if (isCollapsed) {
      <!-- Analytics Dropdown - Collapsed State -->
      <li
        class="dropdown-container d-none d-md-block"
        (mouseenter)="showAnalyticsMenu()"
        (mouseleave)="hideAnalyticsMenu()"
        (click)="toggleAnalyticsMenu()"
      >
        <a
          routerLinkActive="active"
          class="settings-link"
          [class.has-dropdown]="true"
        >
          <mat-icon class="nav-item-icon">insights</mat-icon>
          <span class="menu-label">{{
            "layout.nav.analytics" | translate
          }}</span>
        </a>

        <div
          class="dropdown-menu"
          [class.show]="isAnalyticsMenuOpen"
          (click)="$event.stopPropagation()"
        >
          <ul>
            <li>
              <a
                routerLink="/reports"
                routerLinkActive="active"
                (click)="navigateAndClose('/reports')"
              >
                <mat-icon>assessment</mat-icon>
                <span>{{ "layout.nav.reports" | translate }}</span>
              </a>
            </li>
            <li>
              <a
                routerLink="/dashboardCharts"
                routerLinkActive="active"
                (click)="navigateAndClose('/dashboardCharts')"
              >
                <mat-icon>bar_chart</mat-icon>
                <span>{{ "layout.nav.dashboardCharts" | translate }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    } @else {
      <!-- Analytics Dropdown - Expanded State -->
      <li
        class="dropdown-container d-none d-md-block"
        (click)="toggleAnalyticsMenu()"
      >
        <div class="settings-header">
          <a
            routerLinkActive="active"
            class="settings-link"
            [class.has-dropdown]="true"
            matTooltipPosition="right"
            matTooltipClass="custom-tooltip"
          >
            <mat-icon class="nav-item-icon">insights</mat-icon>
            <span>{{ "layout.nav.analytics" | translate }}</span>
          </a>
          <mat-icon class="arrow" [class.rotate]="isAnalyticsMenuOpen"
            >chevron_right</mat-icon
          >
        </div>

        @if (isAnalyticsMenuOpen) {
          <ul class="settings-children">
            <li>
              <a
                routerLink="/reports"
                routerLinkActive="active"
                (click)="navigateAndClose('/reports')"
              >
                <mat-icon>assessment</mat-icon>
                <span>{{ "layout.nav.reports" | translate }}</span>
              </a>
            </li>
            <li>
              <a
                routerLink="/dashboardCharts"
                routerLinkActive="active"
                (click)="navigateAndClose('/dashboardCharts')"
              >
                <mat-icon>bar_chart</mat-icon>
                <span>{{ "layout.nav.dashboardCharts" | translate }}</span>
              </a>
            </li>
          </ul>
        }
      </li>
    }

    <!-- Change Tracker Report Link -->
    <li>
      <a
        routerLink="/changeTrackerReport"
        routerLinkActive="active"
        (click)="isMobile && toggleSidebar()"
        [matTooltip]="
          isCollapsed && !isMobile
            ? ('layout.nav.changeTrackerReport' | translate)
            : null
        "
        matTooltipPosition="right"
        matTooltipClass="custom-tooltip"
      >
        <mat-icon class="nav-item-icon">track_changes</mat-icon>
        <span class="menu-label">{{
          "layout.nav.changeTrackerReport" | translate
        }}</span>
      </a>
    </li>

    @if (isCollapsed) {
      <!-- Settings Dropdown - Collapsed State -->
      <li
        class="dropdown-container d-none d-md-block"
        (mouseenter)="showSettingsMenu()"
        (mouseleave)="hideSettingsMenu()"
        (click)="toggleSettingsMenu()"
      >
        <a
          routerLinkActive="active"
          class="settings-link"
          [class.has-dropdown]="true"
        >
          <mat-icon class="nav-item-icon">settings</mat-icon>
          <span class="menu-label">{{
            "layout.nav.settings" | translate
          }}</span>
        </a>

        <div
          class="dropdown-menu"
          [class.show]="isSettingsMenuOpen"
          (click)="$event.stopPropagation()"
        >
          <ul>
            <li>
              <a
                routerLink="/myProfile"
                routerLinkActive="active"
                (click)="navigateAndClose('/myProfile')"
              >
                <mat-icon>account_circle</mat-icon>
                <span>{{ "layout.nav.myProfile" | translate }}</span>
              </a>
            </li>
            @if (isAppAdmin) {
              <li>
                <a
                  routerLink="/masterData"
                  routerLinkActive="active"
                  (click)="navigateAndClose('/masterData')"
                >
                  <mat-icon>storage</mat-icon>
                  <span>{{ "layout.nav.masterData" | translate }}</span>
                </a>
              </li>
              <li>
                <a
                  routerLink="/manageUser"
                  routerLinkActive="active"
                  (click)="navigateAndClose('/manageUser')"
                >
                  <mat-icon>people</mat-icon>
                  <span>{{ "layout.nav.manageUsers" | translate }}</span>
                </a>
              </li>
              <li>
                <a
                  routerLink="/syncData"
                  routerLinkActive="active"
                  (click)="navigateAndClose('/syncData')"
                >
                  <mat-icon>sync</mat-icon>
                  <span>{{ "layout.nav.syncData" | translate }}</span>
                </a>
              </li>
            }
          </ul>
        </div>
      </li>
    } @else {
      <!-- Settings Dropdown - Expanded State -->
      <li
        class="dropdown-container d-none d-md-block"
        (click)="toggleSettingsMenu()"
      >
        <div class="settings-header">
          <a
            routerLinkActive="active"
            class="settings-link"
            [class.has-dropdown]="true"
            matTooltipPosition="right"
            matTooltipClass="custom-tooltip"
          >
            <mat-icon class="nav-item-icon">settings</mat-icon>
            <span>{{ "layout.nav.settings" | translate }}</span>
          </a>
          <mat-icon class="arrow" [class.rotate]="isSettingsMenuOpen"
            >chevron_right</mat-icon
          >
        </div>

        @if (isSettingsMenuOpen) {
          <ul class="settings-children">
            <li>
              <a
                routerLink="/myProfile"
                routerLinkActive="active"
                (click)="navigateAndClose('/myProfile')"
              >
                <mat-icon>account_circle</mat-icon>
                <span>{{ "layout.nav.myProfile" | translate }}</span>
              </a>
            </li>
            @if (isAppAdmin) {
              <li>
                <a
                  routerLink="/masterData"
                  routerLinkActive="active"
                  (click)="navigateAndClose('/masterData')"
                >
                  <mat-icon>storage</mat-icon>
                  <span>{{ "layout.nav.masterData" | translate }}</span>
                </a>
              </li>
              <li>
                <a
                  routerLink="/manageUser"
                  routerLinkActive="active"
                  (click)="navigateAndClose('/manageUser')"
                >
                  <mat-icon>people</mat-icon>
                  <span>{{ "layout.nav.manageUsers" | translate }}</span>
                </a>
              </li>
              <li>
                <a
                  routerLink="/syncData"
                  routerLinkActive="active"
                  (click)="navigateAndClose('/syncData')"
                >
                  <mat-icon>sync</mat-icon>
                  <span>{{ "layout.nav.syncData" | translate }}</span>
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</nav>
